{
  "nav": {
    "home": "Home",
    "whatToSee": "What To See",
    "thingsToDo": "Things To Do",
    "stayAndEat": "Stay & Eat",
    "planYourTrip": "Plan Your Trip",
    "becomeAMember": "Become A Member",
    "centralMeskheti": "Central Meskheti",
    "borjomiBakuriani": "Borjomi – Bakuriani",
    "javakheti": "Javakheti",
    "activitiesAndTours": "Activities & Tours",
    "hikingTrailMap": "Hiking Trail Map",
    "events": "Events",
    "agritourism": "Agritourism",
    "hotelsResorts": "Hotels & Resorts",
    "guestHouses": "Guest Houses & Home-stays",
    "wineCulinary": "Wine & Culinary",
    "restaurants": "Restaurants",
    "itineraries": "Itineraries & Tours",
    "brochures": "Brochures",
    "menu": "Menu",
    "expandSection": "Expand {{section}}",
    "collapseSection": "Collapse {{section}}"
  },
  "a11y": {
    "toggleTheme": "Switch to {{mode}} theme",
    "switchLanguage": "Switch language",
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "closeModal": "Close"
  },
  "theme": {
    "light": "light",
    "dark": "dark"
  },
  "hero": {
    "learnMore": "Learn More",
    "infiniteInVariety": "Infinite in Variety"
  },
  "home": {
    "heroTitle": "Samtskhe – Javakheti",
    "heroSubtitle": "Your experience will be infinite in variety",
    "overline": "Your experience will be infinite in variety",
    "planYourTrip": "Plan Your Trip",
    "playVideo": "Play intro video",
    "discoverCardTitle": "Infinite In Variety",
    "discoverCardSubtitle": "Discover Samtskhe – Javakheti",
    "learnMore": "Learn More",
    "follow": "Follow",
    "social_x": "Follow us on X",
    "social_facebook": "Follow us on Facebook",
    "social_instagram": "Follow us on Instagram",
    "social_linkedin": "Follow us on LinkedIn",
    "adventureTitle": "Your Adventure Starts Here",
    "adventureSubtitle": "Don't know where to begin? Here are the top experiences:",
    "trailsPromoTitle": "Check Out All The Hiking Trails In The Area",
    "trailsPromoSubtitle": "Samtskhe-Javakheti is full of majestic places to see, so be ready to take on one of our hiking trails!",
    "trailsFindDestination": "Find Your Destination",
    "trailsCardTitle": "Hiking Trails",
    "trailsCardText": "Travelling is a wonderful way to explore new places, learn about different cultures, and gain unique experiences.",
    "trailsPlayJourney": "Play & Journey",
    "infiniteHeadline": "Infinite Adventure Awaits",
    "infiniteHeadlineAccent": "in SJ",
    "infiniteBody": "Samtskhe-Javakheti, one of the most important historical and ethnographic regions of Georgia, is rich with variety: distinct micro-climates, from snow-packed mountains to lush forests, with pristine rivers and lakes unlike anywhere else on Earth.",
    "infiniteCtaTitle": "Infinite Adventure Awaits You",
    "infiniteCtaSubtitle": "Find activities in Samtskhe – Javakheti",
    "appTitle": "Find Hiking Trails On Our Mobile App",
    "appBody": "HikeSJ — your trail guide to Samtskhe-Javakheti, Georgia. Explore the outdoors with HikeSJ!",
    "appStoreTop": "Download on the",
    "appStoreName": "App Store",
    "playStoreName": "Google Play",
    "highlightsTitle": "Highlights",
    "highlightsSubtitle": "Here are the highlights you might be interested in",
    "appComingSoon": "Coming soon"
  },
  "carousel": {
    "prev": "Previous",
    "next": "Next"
  },
  "footer": {
    "contactUs": "Contact Us",
    "dmo": "Samtskhe-Javakheti DMO",
    "offers": "Offers",
    "getInTouch": "Get In Touch",
    "privacyPolicy": "Privacy Policy",
    "termsOfService": "Terms Of Service",
    "cookiePolicy": "Cookie Policy",
    "news": "News",
    "blog": "Blog",
    "aboutDmo": "About The DMO",
    "projects": "Projects",
    "reports": "Reports",
    "offer_meetings": "Meetings",
    "offer_sports": "Sports",
    "offer_industry": "Industry",
    "offer_travelers": "Travelers",
    "offer_weddings": "Weddings"
  },
  "common": {
    "loading": "Loading…",
    "placeholderPage": "This page is a placeholder — content arrives in a later milestone."
  },
  "map": {
    "homeHeading": "Discover Variety of SJ",
    "homeIntro": "Explore places to see across Samtskhe-Javakheti.",
    "all": "All",
    "viewDetails": "View Details",
    "noResults": "No places match this filter yet."
  },
  "activities": {
    "hubTitle": "Activities & Tours",
    "hubSubtitle": "Find your adventure across Samtskhe-Javakheti",
    "agritourismTitle": "Agritourism",
    "agritourismSubtitle": "Farm stays and rural experiences",
    "findMore": "Find More",
    "learnMore": "Learn More",
    "website": "Website",
    "phone": "Phone",
    "email": "Email",
    "empty": "Nothing published here yet."
  },
  "trails": {
    "title": "Hiking Trail Map",
    "subtitle": "Explore the trails of Samtskhe-Javakheti",
    "routeLength": "Route Length",
    "elevation": "Elevation",
    "routeType": "Route Type",
    "complexity": "Complexity",
    "address": "Address",
    "details": "Details",
    "routeDescription": "Route Description",
    "downloadGpx": "Download GPX",
    "km": "km",
    "empty": "No trails published yet.",
    "allDifficulties": "All difficulties",
    "allRouteTypes": "All route types",
    "difficulty_easy": "Easy",
    "difficulty_medium": "Medium",
    "difficulty_hard": "Hard",
    "routeType_one_way": "One Way",
    "routeType_connecting": "Connecting",
    "routeType_loop": "Loop"
  },
  "events": {
    "title": "Events",
    "subtitle": "What's happening across Samtskhe-Javakheti",
    "view_list": "List",
    "view_month": "Month",
    "details": "Details",
    "when": "When",
    "venue": "Venue",
    "organizer": "Organizer",
    "price": "Price",
    "category": "Category",
    "addToCalendar": "Add to Calendar",
    "venueWebsite": "Venue Website",
    "empty": "No upcoming events yet."
  },
  "accommodations": {
    "subtitle": "Places to stay and dine across Samtskhe-Javakheti",
    "findMore": "Find More",
    "address": "Address",
    "website": "Website",
    "empty": "Nothing published here yet.",
    "hotelsResorts": "Hotels & Resorts",
    "guestHouses": "Guest Houses & Home-stays",
    "wineCulinary": "Wine & Culinary",
    "restaurants": "Restaurants"
  },
  "whatToSee": {
    "title": "What To See",
    "subtitle": "Three regions, infinite in variety",
    "introHeading": "Explore the Regions",
    "introText": "Samtskhe-Javakheti spans three distinct regions. Hover the map or a card to find your way.",
    "findMore": "Find More",
    "discoverRegion": "Discover {{region}}"
  },
  "attraction": {
    "share": "Share Experience",
    "planTrip": "Plan Trip",
    "tips": "Tips"
  },
  "posts": {
    "learnMore": "Learn More",
    "empty": "Nothing published here yet.",
    "news": "News",
    "writtenBy": "Written by",
    "newsTitle": "News",
    "newsHeading": "Highlights",
    "blogTitle": "Blog",
    "blogHeadingAccent": "Insights",
    "blogHeading": "That Ignite Curiosity"
  },
  "projects": {
    "title": "Projects",
    "subtitle": "What the DMO is building across Samtskhe-Javakheti",
    "open": "Open Project",
    "empty": "No projects published yet."
  },
  "reports": {
    "title": "Reports",
    "subtitle": "Publications and statistics from the DMO",
    "open": "Open Report",
    "empty": "No reports published yet."
  },
  "brochures": {
    "title": "Brochures",
    "subtitle": "Download guides to Samtskhe-Javakheti",
    "open": "Open Brochure",
    "empty": "No brochures published yet."
  },
  "pdf": {
    "openInNewTab": "Open in new tab"
  },
  "discover": {
    "hubTitle": "Discover Samtskhe – Javakheti",
    "hubSubtitle": "Infinite in variety",
    "findMore": "Find More"
  },
  "offers": {
    "comingSoon": "Coming Soon",
    "comingSoonSubtitle": "This is not ready yet, but you should see other things."
  },
  "itineraries": {
    "title": "Itineraries & Tours",
    "subtitle": "Suggested routes across Samtskhe-Javakheti",
    "findMore": "Find More",
    "stops": "Stops",
    "days_one": "{{count}} day",
    "days_other": "{{count}} days",
    "empty": "No itineraries published yet."
  },
  "forms": {
    "whoWeAre": "Who We Are",
    "whoWeAreBody": "Samtskhe-Javakheti Destination Management Organization was established in 2019 by all six municipalities of the region, with both the initiative and support of the Georgian National Tourism Administration and USAID Zrda Activity in Georgia.",
    "name": "Name",
    "namePlaceholder": "Enter your name",
    "email": "Email",
    "phone": "Phone",
    "message": "Message",
    "messagePlaceholder": "Type your message",
    "sendMessage": "Send A message",
    "sending": "Sending…",
    "close": "Close",
    "required": "This field is required.",
    "rateLimited": "Too many attempts. Please wait a minute and try again.",
    "genericError": "Something went wrong. Please try again.",
    "contactSentTitle": "Message sent",
    "contactSentBody": "Thank you — we will get back to you soon.",
    "membershipTitle": "Member Registration Form",
    "organizationName": "Organization/Business Name",
    "representative": "Representative of the organization (name/surname)",
    "first": "First",
    "last": "Last",
    "position": "Position",
    "websiteLink": "Website Link",
    "address": "Address of the organization",
    "street": "Street Address",
    "city": "City",
    "country": "Country",
    "selectPackage": "Select the appropriate membership package",
    "package_big_business": "Big Business",
    "package_small_medium_business": "Small and Medium Business",
    "package_individual_member": "Individual Member",
    "package_ngo": "Nongovernmental Organization",
    "secondRepresentative": "Second representative of the organization",
    "registerAsMember": "Register as a member",
    "membershipSentTitle": "Application received",
    "membershipSentBody": "Thank you — our team will review your application and contact you about the next steps."
  },
  "search": {
    "title": "Search",
    "label": "Search the site",
    "placeholder": "Search places, trails, events…",
    "prompt": "Type to search across attractions, activities, trails, events, places to stay and news.",
    "tooShort": "Enter at least {{count}} characters.",
    "empty": "Nothing found for “{{query}}”. Try a shorter or different word.",
    "count_one": "{{count}} result",
    "count_other": "{{count}} results",
    "groups": {
      "attractions": "Attractions",
      "activities": "Activities & Tours",
      "trails": "Hiking Trails",
      "events": "Events",
      "accommodations": "Stay & Eat",
      "posts": "News & Blog"
    }
  },
  "cookies": {
    "title": "Cookie consent",
    "body": "We use analytics cookies to understand how the site is used. They are optional — the site works exactly the same either way.",
    "accept": "Accept",
    "decline": "Decline",
    "policyLink": "Read our cookie policy",
    "manage": "Cookie preferences"
  }
}
